<!-- Payment Card Skeleton Loader Template -->
<!-- Requirements: 15.1, 15.2 -->

<mat-card class="payment-card-skeleton">
  <mat-card-header>
    <div class="header-content">
      <div class="skeleton-title"></div>
    </div>
    <div class="skeleton-chip"></div>
  </mat-card-header>

  <mat-card-content>
    <!-- Payment Info Grid Skeleton -->
    <div class="payment-info-grid">
      <div class="info-item">
        <div class="skeleton-icon"></div>
        <div class="skeleton-text"></div>
      </div>
      <div class="info-item">
        <div class="skeleton-icon"></div>
        <div class="skeleton-text"></div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Progress Section Skeleton -->
    <div class="progress-section">
      <div class="progress-header">
        <div class="skeleton-label"></div>
        <div class="skeleton-value-small"></div>
      </div>
      <div class="skeleton-progress-bar"></div>
      <div class="skeleton-percentage"></div>
    </div>

    <mat-divider></mat-divider>

    <!-- Financial Summary Skeleton -->
    <div class="financial-summary">
      <div class="summary-row">
        <div class="skeleton-label"></div>
        <div class="skeleton-value"></div>
      </div>
      <div class="summary-row">
        <div class="skeleton-label"></div>
        <div class="skeleton-value"></div>
      </div>
      <div class="summary-row">
        <div class="skeleton-label"></div>
        <div class="skeleton-value"></div>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <div class="skeleton-button"></div>
    <div class="skeleton-button"></div>
  </mat-card-actions>
</mat-card>
